export const setWidgetSettings = (data) => {
   return {
      type: "SET_WIDGET_SETTINGS",
      payload: data,
   };
};

export const updateWidgetSettings = (data) => {
   return {
      type: "UPDATE_WIDGET_SETTINGS",
      payload: data,
   };
};
